import { Calendar, Users, Clock, Trophy } from 'lucide-react';
import SEO from '@/components/SEO';

const COURT_OPTIONS = [
  { id: 'open-play', icon: Users, title: 'Open Play', desc: 'Drop-in sessions for all skill levels. No reservation needed during open play hours.' },
  { id: 'private', icon: Clock, title: 'Private Rentals', desc: 'Book the court for your team practice, scrimmage, or private event.' },
  { id: 'league', icon: Trophy, title: 'League Play', desc: 'Join our indoor futsal leagues. Season and tournament formats available.' },
  { id: 'events', icon: Calendar, title: 'Events', desc: 'Host your corporate event, team building, or birthday party on our courts.' },
];

export default function SoccerFutsal() {
  return (
    <div data-testid="soccer-futsal-page" className="pt-[68px]">
      <SEO title="Soccer / Futsal" description="Indoor court space for soccer and futsal — open play, private rentals, and league hosting at Propel Sports NC." path="/soccer-futsal" />
      <section className="relative py-24 bg-[#0B1D3A] overflow-hidden">
        <div className="absolute inset-0 opacity-20" style={{
          backgroundImage: 'radial-gradient(ellipse 600px 400px at 30% 50%, rgba(242,101,34,0.25) 0%, transparent 70%)'
        }} />
        <div className="relative z-10 max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">Soccer / Futsal</h1>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">Indoor court space for soccer and futsal. Open play, private rentals, and league hosting available.</p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {COURT_OPTIONS.map((item) => (
              <div key={item.id} className="bg-gray-50 border border-gray-200 rounded-2xl p-8 hover:border-[#F26522]/30 hover:shadow-lg transition-all">
                <div className="w-12 h-12 rounded-xl bg-[#F26522]/10 flex items-center justify-center mb-4">
                  <item.icon size={24} className="text-[#F26522]" />
                </div>
                <h3 className="text-xl font-bold text-[#0B1D3A] mb-2">{item.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <a
              href="https://propelsports.myesoftplanner.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="soccer-book-now"
              className="inline-flex items-center gap-2 bg-[#F26522] hover:bg-[#D9551A] text-white px-8 py-4 rounded-lg font-semibold transition-all hover:shadow-xl hover:shadow-orange-500/20"
            >
              <Calendar size={18} />
              Book Court Time
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
